export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0xD7aA03104c2CCaC58acB00CbE90865FA64BbE77D",
  eulerSwapV1Implementation: "0x7F6ff62e7ECED715a2f4E5Ebe14eC9d32a44EFDc",
  eulerSwapV1Periphery: "0x1472ebB000190275B5e28733e45a2614F1C3F41C",
} as const
